import { useGomakeTheme } from "@/hooks/use-gomake-thme";

const PencilLineIcon = (props: any) => {
  const { primaryColor } = useGomakeTheme();
  const strokeColor = props.stroke || primaryColor(500);
  
  return (
    <svg
      width={props.width || props.style?.fontSize || "16"}
      height={props.height || props.style?.fontSize || "16"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      className={props.className}
    >
      <path
        d="M13 21h8"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m15 5 4 4"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { PencilLineIcon };
